import { Grid, Button, TextField } from "@mui/material";
import { SearchParticipantProps } from "../interfaces/interfaces";
import { SearchParticipantContext } from "../context/searchParticipantContext";
import React from "react";

const SearchForm = (): React.JSX.Element => {
  const {
    searchParameters,
    setSearchParameters,
    startSearch,
  }: {
    searchParameters: SearchParticipantProps;
    setSearchParameters: (searchParameters: SearchParticipantProps) => void;
    startSearch: () => void;
  } = React.useContext(SearchParticipantContext);

  const noInput =
    searchParameters.firstName === "" &&
    searchParameters.lastName === "" &&
    searchParameters.email === "";

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        startSearch();
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3}>
          <TextField
            disabled={searchParameters.loading}
            fullWidth
            id="firstName"
            label="Vorname"
            color="secondary"
            variant="outlined"
            value={searchParameters.firstName}
            onChange={(e) =>
              setSearchParameters({
                ...searchParameters,
                firstName: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <TextField
            disabled={searchParameters.loading}
            fullWidth
            id="lastName"
            label="Nachname"
            color="secondary"
            variant="outlined"
            value={searchParameters.lastName}
            onChange={(e) =>
              setSearchParameters({
                ...searchParameters,
                lastName: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <TextField
            disabled={searchParameters.loading}
            fullWidth
            id="email"
            label="E-Mail"
            color="secondary"
            type="email"
            variant="outlined"
            value={searchParameters.email}
            onChange={(e) =>
              setSearchParameters({
                ...searchParameters,
                email: e.target.value,
              })
            }
          />
        </Grid>

        <Grid item xs={12} sm={12} md={3}>
          <Button
            disabled={noInput || searchParameters.loading}
            type="submit"
            sx={{
              height: "100%",
              width: "100%",
            }}
            variant="contained"
            color="primary"
          >
            Suchen
          </Button>
        </Grid>
      </Grid>
    </form>
  );
};

export default SearchForm;
